import { render, staticRenderFns } from "./diagnostic.vue?vue&type=template&id=53fb34fe"
import script from "./diagnostic.vue?vue&type=script&lang=js"
export * from "./diagnostic.vue?vue&type=script&lang=js"
import style0 from "./diagnostic.vue?vue&type=style&index=0&id=53fb34fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports